import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Close mobile menu on route change
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/our-approach', label: 'Our Approach' },
    { path: '/margin-integrity-review', label: 'Margin Integrity Review' },
    { path: '/who-we-work-with', label: 'Who We Work With' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav
      className="sticky top-0 left-0 right-0 z-50 bg-white border-b border-gray-200/70"
      style={{ fontFamily: 'Inter, sans-serif' }}
    >
      <div className="w-full px-2 lg:px-5 xl:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center cursor-pointer py-0">
            <img
              src="https://static.readdy.ai/image/74aaa5890e80b03ee640528edfaa25c4/2d85756bdda65ea39650f591d5a0b427.png?crop=tight"
              alt="Vantage Commercial Advisory"
              className="h-[46px] w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation Links */}
          <div className="hidden lg:flex items-center gap-3 xl:gap-5">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[13px] font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#111111]'
                    : 'text-[#333333] hover:text-[#111111]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:block">
            <Link
              to="/contact"
              className="inline-flex items-center px-5 py-2 bg-[#B8963E] text-white text-[13px] font-medium rounded-md hover:bg-[#A6862F] transition-colors cursor-pointer whitespace-nowrap"
            >
              Request a Free Confidential Discussion
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i
              className={`${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              } text-xl text-[#2B2D42]`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200/70">
          <div className="px-6 py-5 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block text-sm font-medium py-1.5 transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#111111]'
                    : 'text-[#333333] hover:text-[#111111]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3 border-t border-gray-100">
              <Link
                to="/contact"
                className="block w-full text-center bg-[#B8963E] text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-[#A6862F] transition-colors cursor-pointer whitespace-nowrap"
              >
                Request a Free Confidential Discussion
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
